import { useLocationQuery } from '@avangard/utils/hooks';

import { tablePerPage } from '@modules/layout/constants/table';

import type { LocationQuery } from '@avangard/utils/hooks';
import type { Sort } from '@modules/types/graphql';

export type TableFiltersQuery = {
    filters: {
        page: number;
        perPage: number;
        orderBy?: string;
        orderDirection?: Sort;
        orderField?: string | string[];
        orderByWith?: string;
    };

    hasQuery: boolean;
} & Pick<LocationQuery, 'query' | 'setQuery'>;

const useTableFiltersQuery = (): TableFiltersQuery => {
    const { query, setQuery } = useLocationQuery();

    const result = {
        filters: {
            page: query.page ? parseInt(query.page as string, 10) : 1,
            perPage: query.perPage ? parseInt(query.perPage as string, 10) : tablePerPage[1].value,
            orderBy: query.orderBy ? (query.orderBy as string) : undefined,
            orderField: query.orderField ?? undefined,
            orderDirection: query.orderDirection ? (query.orderDirection as Sort) : undefined,
            orderByWith: query.orderByWith ? (query.orderByWith as string) : undefined,
        },
        query,
        setQuery,
        hasQuery: Object.keys(query).length > 0,
    };

    return result;
};

export { useTableFiltersQuery };
